<script>
import GenericCrud from "@forms/GenericCrud.vue";
import api from "@services/api";

export default {
  extends: GenericCrud,
  props: {
    table: {
      type: String,
      default: "ProjetoExtrato"
    }
  },
  data: () => ({
    item: { fechado: true },
    clienteList: {},
    projetoList: undefined,
    clienteId: undefined,
    projetoId: undefined
  }),
  watch: {
    clienteId: function() {
      this.item.clienteId = this.clienteId;
      this.getProjetoList();
    },
    projetoId: function() {
      if (this.projetoList) {
        let projeto = this.projetoList.filter(
          a => a.projetoId === this.projetoId
        )[0];
        if (projeto) {
          this.item.projetoId = projeto.projetoId;
        }
      }
    }
  },
  created() {
    this.getClienteList();
  },
  methods: {
    get(id) {
      api
        .get(`crud/${this.table}/${id}`, {
          params: {
            include: "Projeto,Projeto.Contrato"
          }
        })
        .then(response => {
          this.item = response.data["data"];
          this.clienteId = this.item.projeto.contrato.clienteId;
          this.projetoId = this.item.projetoId;
        });
    },
    getClienteList() {
      api
        .get(`crud/Cliente`, {
          params: {
            sortBy: "nome",
            sortOrder: "ASC"
          }
        })
        .then(response => (this.clienteList = response.data["data"]));
    },
    getProjetoList() {
      if (this.clienteId) {
        api
          .get(`crud/Expediente/Projetos`, {
            params: {
              clienteId: this.clienteId,
              ativo: false
            }
          })
          .then(response => {
            this.projetoList = response.data["data"];
            if (this.projetoList.length > 0) {
              this.projetoId = this.projetoList[0].projetoId;
            }
          });
      }
    }
  }
};
</script>

<template>
  <div>
    <b-form @submit.prevent="save">
      <div class="row">
        <b-form-group
          class="col-md-4"
          id="input-group-1"
          label="Cliente"
          label-for="clienteId"
        >
          <b-form-select
            id="clienteId"
            v-model="clienteId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option disabled :value="undefined"
              >Selecione um item da lista</b-form-select-option
            >
            <b-form-select-option
              v-for="option in clienteList"
              :key="option.id"
              :value="option.id"
            >
              {{ option.nome }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>

        <b-form-group
          class="col-md-8"
          id="input-group-1"
          label="Projeto"
          label-for="projetoId"
        >
          <b-form-select
            id="projetoId"
            v-model="projetoId"
            :disabled="!this.editForm"
            required
          >
            <b-form-select-option
              disabled
              :value="undefined"
              v-if="!projetoList"
              >Selecione um Cliente</b-form-select-option
            >
            <b-form-select-option
              v-for="option in projetoList"
              :key="option.projetoId"
              :value="option.projetoId"
            >
              {{ option.descricao }}
            </b-form-select-option>
          </b-form-select>
        </b-form-group>
      </div>
      <div class="row">
        <b-form-group
          id="input-group-1"
          label="Ano Mês"
          label-for="anomes"
          class="col-md-9"
        >
          <b-form-input
            id="anomes"
            v-model="item.anoMes"
            :disabled="!this.editForm"
            type="text"
            v-mask="'######'"
            placeholder="aaaaMM"
            required
          ></b-form-input>
        </b-form-group>
        <b-form-group id="input-group-1" class="text-center mt-4 col-md-3">
          <b-form-checkbox
            v-model="item.fechado"
            :disabled="!this.editForm"
            name="check-button"
            switch
          >
            Fechado
          </b-form-checkbox>
        </b-form-group>
      </div>

      <b-form-group id="button-group" class="mt-4" v-show="this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Cancelar</b-button
        >
        <b-button type="submit" variant="primary" class="btn ml-2"
          >Salvar</b-button
        >
      </b-form-group>

      <b-form-group id="button-group" class="mt-4" v-show="!this.editForm">
        <b-button variant="light" class="btn" v-on:click="back()"
          >Voltar</b-button
        >
        <b-button variant="primary" class="btn ml-2" v-on:click="edit()"
          >Editar</b-button
        >
        <b-button variant="danger" class="btn ml-2" v-on:click="remove()"
          >Remover</b-button
        >
      </b-form-group>
    </b-form>
    <b-modal
      v-model="showModalDelete"
      title="Deseja realmente excluir?"
      centered
      hide-footer
      @hidden="cancelRemove()"
    >
      <div class="button-list float-right">
        <b-button
          class="btn btn btn-icon"
          variant="primary"
          v-on:click="confirmRemove()"
          >Sim</b-button
        >
        <b-button
          class="btn btn btn-icon"
          variant="light"
          @click="showModalDelete = false"
          >Não</b-button
        >
      </div>
    </b-modal>
  </div>
</template>
